// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"6914f20d","637":"6914f20d"}[chunkId] + ".chunk.css";
};